<script setup>
import Modal from '@/components/Shared/Modal.vue';
import FormInputLabel from '@/components/Shared/Form/Input/Label.vue';
import JsonViewer from '@/components/Shared/JsonViewer.vue';
import FormInput from "@/components/Shared/Form/Input/Index.vue";

const emit = defineEmits(['close']);
const props = defineProps({
  changeLog: {
    type: Object,
    required: true,
  },
});

const handleClose = () => {
  emit('close');
};
</script>

<template>
  <modal
    :show="true"
    name="change-log-modal"
    @close="handleClose"
    :content-style="['overflow-y: auto', 'min-width: 50%']"
  >
    <template #title>
      <h2 class="text-90 font-normal text-xl">{{ changeLog.title }}</h2>
    </template>

    <template #content>
      <div class="my-4">
        <form-input :label-text="trans('audit.cause')" v-model="changeLog.cause" disabled/>
      </div>
      <div class="my-4">
        <form-input :label-text="trans('audit.ip_address')" v-model="changeLog.ipAddress" disabled/>
      </div>
      <div class="my-4">
        <form-input-label :value="trans('audit.old_value')"/>
        <div class="p-3" style="background-color: #f5f5f5">
          <json-viewer :data="changeLog.oldValue"/>
        </div>
      </div>
      <div class="my-4">
        <form-input-label :value="trans('audit.new_value')"/>
        <div class="p-3" style="background-color: #f5f5f5">
          <json-viewer :data="changeLog.newValue"/>
        </div>
      </div>
    </template>
    <template #footer>
      <button type="button" @click.prevent="handleClose" class="button button_secondary">
        {{ trans('common.close') }}
      </button>
    </template>
  </modal>
</template>
